import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { InstagramIcon, GlobeIcon, ExternalLinkIcon } from 'lucide-react';
export function Team() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  const team = [{
    name: 'Dimi',
    role: 'Fotograf & Creative Direction',
    description: 'Mit großer Reichweite auf Instagram bringt Dimi nicht nur fotografisches Können, sondern auch eine starke Community mit.',
    image: 'https://cdn.rawproductionsgmbh.de/shootingtrip/portugalmai2026/fotograf/dimi.jpg',
    instagram: 'di_mi84',
    instagramLink: 'https://www.instagram.com/di_mi84/',
    links: [{
      label: 'Website',
      href: 'https://dimi-raws.com/',
      icon: GlobeIcon
    }, {
      label: 'Model-Kartei',
      href: 'https://www.model-kartei.de/sedcards/fotograf/662636/di-mi84/',
      icon: ExternalLinkIcon
    }]
  }, {
    name: 'Chris',
    role: 'Fotograf & FPV-Drohne',
    description: 'Chris sorgt mit seiner FPV-Drohne für eindrucksvolle Aufnahmen aus Perspektiven, die sonst niemand einfängt.',
    image: 'https://cdn.rawproductionsgmbh.de/shootingtrip/portugalmai2026/fotograf/chris.jpg',
    instagram: 'thechrissander',
    instagramLink: 'https://www.instagram.com/thechrissander/',
    links: []
  }, {
    name: 'Basti',
    role: 'Fotograf & Verpflegung',
    description: 'Basti kümmert sich um die Verpflegung und sorgt dafür, dass neben großartigen Bildern auch das leibliche Wohl stimmt.',
    image: 'https://cdn.rawproductionsgmbh.de/shootingtrip/portugalmai2026/fotograf/basti.jpg',
    instagram: 'pietsch.sebastian',
    instagramLink: 'https://www.instagram.com/pietsch.sebastian/',
    links: []
  }];
  return <section id="team" className="py-24 md:py-32 px-6 bg-[#f5f5f7]" data-id="element-318">
      <div className="max-w-7xl mx-auto" data-id="element-319">
        <div className="text-center mb-16" data-id="element-320">
          <span className="block text-xs font-body tracking-[0.3em] text-brand-accent uppercase mb-4" data-id="element-321">
            Das Team
          </span>
          <h2 className="text-4xl md:text-5xl font-heading text-[#1a1a2e] mb-4" data-id="element-322">
            Die Köpfe hinter der Reise.
          </h2>
          <p className="text-[#4a4a5a] font-light max-w-2xl mx-auto" data-id="element-323">
            Organisiert von{' '}
            <a href="https://studio-nbg.de" target="_blank" rel="noopener noreferrer" className="text-brand-accent hover:underline" data-id="element-324">
              studio-nbg.de
            </a>{' '}
            — drei Fotografen mit Leidenschaft für kreative Projekte.
          </p>
        </div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={containerVariants} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-325">
          {team.map((member, index) => <motion.div key={index} variants={cardVariants} className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300 border border-[#e2e2e6]" data-id="element-326">
              <div className="aspect-square overflow-hidden" data-id="element-327">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" data-id="element-328" />
              </div>
              <div className="p-8" data-id="element-329">
                <h3 className="text-2xl font-heading text-[#1a1a2e] mb-1" data-id="element-330">
                  {member.name}
                </h3>
                <p className="text-brand-accent text-sm font-medium mb-4" data-id="element-331">
                  {member.role}
                </p>
                <p className="text-[#4a4a5a] font-light text-sm leading-relaxed mb-6" data-id="element-332">
                  {member.description}
                </p>
                <div className="flex flex-wrap items-center gap-3" data-id="element-333">
                  <a href={member.instagramLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-[#8a8a9a] hover:text-brand-accent transition-colors" data-id="element-334">
                    <InstagramIcon size={16} data-id="element-335" />
                    <span data-id="element-336">@{member.instagram}</span>
                  </a>
                  {member.links.map((link, i) => <a key={i} href={link.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-xs text-[#8a8a9a] hover:text-brand-accent transition-colors border border-[#e2e2e6] rounded-full px-3 py-1" data-id="element-337">
                      <link.icon size={12} data-id="element-338" />
                      <span data-id="element-339">{link.label}</span>
                    </a>)}
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}